var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.nativeComponent)?_c(_vm.nativeComponent,{ref:"nativeReportRef",tag:"component"}):_c('PowerBIReport',{attrs:{"id":_vm.decodedIDs.reportID,"company-id":_vm.decodedIDs.companyID,"height":_vm.reportHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }